import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { AiBanner } from '@/shared/uikitV2/AiBanner';

export const ExtractBanner: FC = () => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'extractModal' });

  return <AiBanner title={t('bannerTitle')} description={t('bannerText')} />;
};
